import { CommonModule, NgOptimizedImage } from '@angular/common';
import {
  Component,
  Input,
  OnInit,
  ViewChild,
  Output,
  EventEmitter,
  ElementRef,
  AfterViewInit,
} from '@angular/core';
import { debounceTime, distinctUntilChanged, filter, fromEvent, tap } from 'rxjs';

@Component({
  selector: 'div[app-search]',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss'],
  imports: [CommonModule, NgOptimizedImage],
})
export class SearchComponent implements OnInit, AfterViewInit {
  @Output() onSearch = new EventEmitter<string>();
  @Input() placeholder = 'Search here';
  @Input() active = false;
  @Input() SearchBtn = false;
  @Input() disabled = false;
  @Input() searchIcon: boolean = true;
  @Input() size: 'medium' | 'large' = 'medium';
  @Input() searchString = '';

  @ViewChild('search') search!: ElementRef;
  constructor() {}

  ngOnInit(): void {}

  ngAfterViewInit() {
    fromEvent(this.search?.nativeElement, 'keyup')
      .pipe(
        filter(Boolean),
        debounceTime(500),
        distinctUntilChanged(),
        tap(() => {
          this.onSearch.emit(this.search?.nativeElement.value);
        })
      )
      .subscribe();
    if (this.active) {
      this.search.nativeElement.focus();
    }
  }

  public get classes(): string[] {
    const mode = 'Large';
    return [mode];
  }

  setSearchValue(value: string) {
    this.searchString = value;
    if (this.search) {
      this.search.nativeElement.value = value;
      this.onSearch.emit(value);
    }
  }
}
